import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import api from '../utils/api'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await api.post('/auth/forgot-password', { 
        email, 
        name, 
        birth_date: birthDate 
      })
      
      if (response.data.success && response.data.resetToken) {
        // 본인 확인 성공 - 비밀번호 재설정 페이지로 이동
        navigate('/reset-password', { 
          state: { resetToken: response.data.resetToken } 
        })
      } else {
        setError(response.data.error || '본인 확인에 실패했습니다.')
      }
    } catch (err: any) {
      setError(err.response?.data?.error || '본인 확인에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container">
      <div style={{ maxWidth: '400px', margin: '50px auto' }}>
        <div className="card">
          <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>비밀번호 찾기</h2>
          
          <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
            가입하신 이메일, 이름, 생년월일을 입력하시면 본인 확인 후 비밀번호를 재설정할 수 있습니다.
          </p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>이메일</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="가입하신 이메일 주소"
              />
            </div>

            <div className="form-group">
              <label>이름</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                disabled={loading}
                placeholder="가입하신 이름"
              />
            </div>

            <div className="form-group">
              <label>생년월일</label>
              <input
                type="date"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                required
                disabled={loading}
                max={new Date().toISOString().split('T')[0]}
                min="1900-01-01"
              />
              <small style={{ color: '#666', fontSize: '12px' }}>
                가입 시 입력하신 생년월일을 입력해주세요. (생년은 4자리)
              </small>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? '본인 확인 중...' : '본인 확인'}
            </button>
          </form>

          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <Link to="/login">로그인으로 돌아가기</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword

